<div class="scoring">
    <div class="score-item">
        <div class="score-info">
            <div>Områdescore</div>
            @if (scoringValues().areaMarketScoreMin && scoringValues().areaMarketScoreMin !== scoringValues().areaMarketScoreMin &&
            scoringValues().areaMarketScoreMax) { Fra {{ scoringValues().areaMarketScoreMin && scoringValues().areaMarketScoreMin }} til
            {{ scoringValues().areaMarketScoreMax && scoringValues().areaMarketScoreMax }} av 20 } @else {
            <span>{{ scoringValues().areaMarketScore }} av 20</span>
            }
        </div>
        <div>
            <div
                class="scores" 
                cdkOverlayOrigin #marketScoreMin="cdkOverlayOrigin"
                class="score clickable"
                [ngClass]="scoreIconClass(scoringValues().areaMarketScoreMin)"
                [class.hidden]="!scoringValues().areaMarketScoreMin || scoringValues().areaMarketScoreMin === scoringValues().areaMarketScore"
                (click)="areaScoreMinTooltipVisible = true"
            >
                <div class="score-value">
                    {{ scoringValues().areaMarketScoreMin }}
                </div>
            </div>
            <div 
                class="score clickable"
                cdkOverlayOrigin #areaScore="cdkOverlayOrigin" 
                [ngClass]="scoreIconClass(scoringValues().areaMarketScore)" (click)="areaScoreTooltipVisible = true">
                <div class="score-value">
                    {{ scoringValues().areaMarketScore }}
                </div>
            </div>
            
            <ev-cdk-tooltip
                [origin]="areaScore"
                (close)="areaScoreTooltipVisible = false"
                [visible]="areaScoreTooltipVisible"
                [title]="'Områdescore'"
            >
                <div class="score-tooltip">
                    <div class="score" [ngClass]="scoreIconClass(scoringValues().areaMarketScore)">
                        <div class="score-value">
                            {{ scoringValues().areaMarketScore }}
                        </div>
                    </div>
                    <div class="tooltip-text">
                        En områdescore på {{ scoringValues().areaMarketScore }} av 20 betyr at eiendommen ligger i et
                        {{ getScoreCategory(scoringValues().areaMarketScore) }} boligmarked.
                    </div>
                </div>
                <div tooltipFooter>
                    <div class="tooltip-footer">
                        <div class="fact-sheet" (click)="openPdfGuide()">Slik fungerer områdescore</div>
                    </div>
                </div>
            </ev-cdk-tooltip>
            <ev-cdk-tooltip
                [origin]="marketScoreMin"
                (close)="areaScoreMinTooltipVisible = false"
                [visible]="areaScoreMinTooltipVisible"
                [title]="'Områdescore'"
            >
                <div class="score-tooltip">
                    <div class="score" [ngClass]="scoreIconClass(scoringValues().areaMarketScoreMin)">
                        <div class="score-value">
                            {{ scoringValues().areaMarketScoreMin }}
                        </div>
                    </div>
                    <div class="tooltip-text">
                        Et områdescore på {{ scoringValues().areaMarketScoreMin }} av 20 betyr at eiendommen ligger i et
                        {{ getScoreCategory(scoringValues().areaMarketScoreMin) }} boligmarked.
                    </div>
                </div>
                <div tooltipFooter>
                    <div class="tooltip-footer">
                        <div class="fact-sheet" (click)="openPdfGuide()">Slik fungerer områdescore</div>
                    </div>
                </div>
            </ev-cdk-tooltip>
        </div>
    </div>

    <div class="score-item">
        <div class="score-info">
            <div>Kommunescore</div>
            <span>{{ scoringValues().councilScore }} av 20</span>
        </div>
        <div class="scores" cdkOverlayOrigin #councilScore="cdkOverlayOrigin">
            <div class="score clickable" [ngClass]="scoreIconClass(scoringValues().councilScore)" (click)="councilScoreTooltipVisible = true">
                <div class="score-value">
                    {{ scoringValues().councilScore }}
                </div>
            </div>

            <ev-cdk-tooltip
                [origin]="councilScore"
                (close)="councilScoreTooltipVisible = false"
                [visible]="councilScoreTooltipVisible"
                [title]="'Kommunescore'"
                width="320px"
            >
                <div class="score-tooltip">
                    <div class="score" [ngClass]="scoreIconClass(scoringValues().councilScore)">
                        <div class="score-value">
                            {{ scoringValues().councilScore }}
                        </div>
                    </div>
                    <div class="tooltip-text">
                        <div>
                            Et områdescore på {{ scoringValues().councilScore }} av 20 betyr at eiendommen ligger i et
                            {{ getScoreCategory(scoringValues().councilScore) }} boligmarked.
                        </div>
                        <div>Det kan være store forskjeller innad i enkelte kommuner. Vi anbefaler derfor også å se på områdescore.</div>
                    </div>
                </div>
                <div tooltipFooter>
                    <div class="tooltip-footer">
                        <div class="fact-sheet" (click)="openPdfGuide()">Slik fungerer kommunescore</div>
                    </div>
                </div>
            </ev-cdk-tooltip>
        </div>
    </div>
</div>
